import { Data2, newId } from '../../../features/data-types'
import { O } from '../../../features/ui'
import { useSystemStateHooks } from '../../system'
import { Customer, CustomerCategory, CustomerCreditAccount } from '../state/types'
import { VatCondition } from '../../administration'
import { Address } from '../../../features/address'
import { IdentifierType } from '../../system'

export const useCustomerBuilders = () => {
    const { companyId } = useSystemStateHooks()

    const buildCustomer = (data: Data2) => {
        const {
            id = newId(),
            name,
            identifierType,
            identifier,
            category,
            customerTypeId,
            emails,
            phones,
            mainAddress,
            deliveryAddresses = [],
            vatCondition,
            contactName,
            contactPhone,
            creditAccount,
            creditInFavor,
            archived
        } = data

        const customer: Customer = {
            companyId: companyId!,
            id: id! as string,
            name: name! as string,
            identifierType: identifierType! as IdentifierType,
            identifier: identifier! as number,
            category: (category || CustomerCategory.NATURAL) as CustomerCategory,
            customerTypeId: customerTypeId! as string,
            emails: (emails || []) as string[],
            phones: (phones || []) as number[],
            mainAddress: mainAddress as O<Address>,
            deliveryAddresses: (deliveryAddresses || []) as Address[],
            vatCondition: vatCondition! as VatCondition,
            contactName: contactName as O<string>,
            contactPhone: contactPhone as O<number>,
            creditAccount: creditAccount as O<CustomerCreditAccount>,
            creditInFavor: creditInFavor as O<number>,
            archived: !!archived
        }

        return customer
    }

    const buildCreditAccount = (data: Data2) => {
        const { creditLimit, creditDays } = data

        const creditAccount: CustomerCreditAccount = {
            creditLimit: creditLimit! as number,
            creditDays: creditDays! as number
        }

        return creditAccount
    }

    return {
        buildCustomer,
        buildCreditAccount
    }
}
